import * as React from 'react';

import {InfoIcon} from '../icon/svg/info-icon';

import styles from './help-styles.module.css';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    variant?: 'error' | 'green' | 'blue';
    size?: number;
    noPadding?: boolean;
};

// @ts-expect-error
export const HelpButton = React.forwardRef<Props, HTMLButtonElement>((props: Props, ref) => {
    const getStyleName = () => {
        if (props.variant === 'error') {
            return styles['help-icon--error'];
        }

        if (props.variant === 'green') {
            return styles['help-icon--green'];
        }

        if (props.variant === 'blue') {
            return styles['help-icon--blue'];
        }

        if (props.noPadding) {
            return styles['help-icon--no-padding'];
        }

        return styles['help-icon'];
    };

    return (
        // @ts-expect-error
        <button type='button' onClick={props.onClick} ref={ref} className={getStyleName()}>
            <InfoIcon
                wrapWithDiv={false}
                size={props.size ? props.size : 16}
                // @ts-expect-error
                useCurrentColor={true}
            />
        </button>
    );
});
